import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PropTypes from "prop-types";

import HeaderWrapper from "../common/HeaderWrapper";
import DepartmentList from "./DepartmentList";
import DepartmentForm from "./DepartmentForm";
import Modal from "../common/Modal";

import * as departmentActions from "../../actions/departmentActions";
import * as modalActions from "../../actions/modalActions";
import * as serviceActions from "../../actions/serviceActions";

const DepartmentPage = ({ actions, isMobile, departments, services }) => {
  const [selectedRow, setSelectedRow] = useState({});
  useEffect(() => {
    const getDepartments = async () => {
      await actions.loadDepartments();
    };
    if (!departments.length) {
      getDepartments();
    }
  }, [departments, actions]);

  useEffect(() => {
    const getServices = async () => {
      await actions.loadServices();
    };
    if (!services?.length) {
      getServices();
    }
  }, [services, actions]);

  const handleRowClick = (rowInfo) => {
    setSelectedRow(rowInfo.original);
    actions.showModal("departmentDetails");
  };

  const handleRefreshData = async () => {
    await actions.loadDepartments();
    actions.hideModal();
  };

  const departmentDetailsForm = (
    <DepartmentForm
      department={selectedRow}
      onClose={actions.hideModal}
      onSave={handleRefreshData}
    />
  );

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[{ label: "Settings" }, { label: "Departments" }]}
        isMobile={isMobile}
      />
      <div className="content-wrapper">
        <DepartmentList
          departments={departments}
          onRowClick={handleRowClick}
          services={services}
        />
      </div>
      <Modal
        id="departmentDetails"
        title="Edit Department"
        body={departmentDetailsForm}
        close={actions.hideModal}
      />
    </React.Fragment>
  );
};

DepartmentPage.propTypes = {
  actions: PropTypes.object,
  isMobile: PropTypes.bool,
  departments: PropTypes.array,
  services: PropTypes.array
};

function mapStatesToProps(state) {
  return {
    departments: state.reducers.departments,
    services: state.reducers.services
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...modalActions,
        ...departmentActions,
        ...serviceActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(DepartmentPage);
